var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshRightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM12 18.01C8.83 18.01 6.25 15.43 6.25 12.26C6.25 9.09 8.83 6.51 12 6.51C12.14 6.51 12.29 6.53 12.43 6.54L12.15 6.22C11.88 5.91 11.91 5.43 12.22 5.16C12.53 4.89 13.01 4.92 13.28 5.23L14.95 7.14C14.96 7.15 14.96 7.16 14.97 7.17C14.98 7.18 14.99 7.18 14.99 7.19C15.01 7.22 15.02 7.26 15.04 7.3C15.06 7.35 15.09 7.39 15.1 7.44C15.11 7.49 15.11 7.53 15.12 7.58C15.12 7.63 15.13 7.67 15.13 7.72C15.13 7.77 15.11 7.81 15.09 7.86C15.07 7.91 15.06 7.96 15.04 8C15.02 8.04 14.98 8.08 14.95 8.12C14.92 8.15 14.91 8.19 14.88 8.21C14.87 8.22 14.86 8.22 14.85 8.23C14.84 8.24 14.84 8.25 14.83 8.25L12.89 9.67C12.76 9.77 12.6 9.81 12.45 9.81C12.22 9.81 11.99 9.7 11.84 9.5C11.6 9.17 11.67 8.7 12 8.45L12.56 8.04C12.37 8.03 12.19 8.01 12 8.01C9.66 8.01 7.75 9.92 7.75 12.26C7.75 14.6 9.66 16.51 12 16.51C14.34 16.51 16.25 14.6 16.25 12.26C16.25 11.41 16 10.6 15.54 9.9C15.31 9.56 15.4 9.09 15.75 8.86C16.09 8.63 16.56 8.72 16.79 9.07C17.42 10.02 17.76 11.12 17.76 12.26C17.75 15.44 15.17 18.01 12 18.01Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshRightSquare);
export default __webpack_public_path__ + "static/media/refresh-right-square.9a2a02052290c7a3d9cfad803f081240.svg";
export { ForwardRef as ReactComponent };